'use strict';

import React, { useEffect, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import SoRewardCard from './SoRewardCard'

import { isTrue } from '@root/utility'

const { app } = window;

export default PageWrapper(function SynerKadoPage (props)
{
	const [__disabled_with_card, setDWC] = useState(
		isTrue(app?.state?.session?.__disabled_with_card)
	);

	useEffect(function ()
	{
		app.push(
		{
			event: 'sessionChange',
			cb: handleSessionChange
		});

		handleSessionChange();

		return () => app.delete(
		{
			event: 'sessionChange',
			cb: handleSessionChange
		});

		function handleSessionChange ()
		{
			setDWC(isTrue(app?.state?.session?.__disabled_with_card));
		}
	},
	[]);

	if (__disabled_with_card)
	{
		return (
			<div className="page-content">

				<div className="o-content">

					<SoRewardCard />

				</div>

			</div>
		);
	}

	return (
		<Layout page_title="Mon compte" history={ props.history }>

			<div className="page-content">

				<HolidaysMessage />

				<div className="o-content">

					<SoRewardCard />

				</div>

			</div>

		</Layout>
	);
});